const hy = {
  greatJobTxt: 'Great job!',
  greatJobFor100: 'Wow! This was LEGENDARY!',
  pointsTxt: 'points',
  failedQuestions: 'You didn’t pass these questions',
  passedQuestion: 'You passed these questions',
  recommendationTxt: 'Recommended reading',
  reminderTxt: 'Remind Me',
  nextTestTxt: 'Next test available in',
  startBtn: 'Begin Test',
  finalTest: 'Final Test',
  continueTest: 'Continue Test',
  done: 'Done',
  insight: 'Genuine knowledge requires patience and dedication.',
  achievementUnlocked: 'Achievement unlocked!',
  clickMe: 'Click Me! ^_^',
  passedFinalTest: 'You did it!!!',
  passedFinalTestSubtext:
    'Endgame awaits! Now you can unlock unique rewards while honing your knowledge every day.',
  failedFinalTest: "Didn't make it.",
  failedFinalTestSubtext:
    'Try again tomorrow. The completion certificate is worth it!',
  encouragement: "Don't be sad. Check recommended reading below 🌻",
  betterLuckNextTime: 'Better luck next time!',
  testIsAvailable: 'AVAILABLE NOW!',
  pleaseRateFirstWord: 'Please',
  pleaseRate: 'rate your experience',
  levelUp: 'Level up!',
  calculatingTitle: 'Calculating results',
  analyzingAnswers: 'Analyzing your answers',
  consultingWithBob: 'Consulting with Bob GPT',
  achievementProgress: 'Analyzing achievements progress',
  recommendedReading: 'Generating recommended reading',
};
export default hy;
